<template>
  <div
    id="data-list-list-view"
    class="mt-3 data-list-container flipthis-highlight vs-con-loading__container"
  >
    <vs-table
      ref="table"
      :sst="true"
      :data="entidades"
      @sort="handleOrdenacao"
      noDataText="Nenhum dado disponível com os filtros selecionados."
    >
      <template slot="thead" v-if="entidades.length">
        <vs-th sort-key="id">#</vs-th>
        <vs-th sort-key="nome">Nome</vs-th>
        <vs-th v-if="todasAsAssociacoes" sort-key="associacao">Associação</vs-th>
        <!-- <vs-th></vs-th> -->
      </template>

      <template>
        <tbody>
          <vs-tr :data="entidade" :key="indextr" v-for="(entidade, indextr) in entidades">
            <vs-td>
              <p class="product-name font-medium main-menu-sidebar">{{ entidade.id }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-semibold main-menu-sidebar">{{ entidade.nome }}</p>
            </vs-td>

            <vs-td v-if="todasAsAssociacoes">
              <p
                class="product-name font-semibold main-menu-sidebar"
              >{{ entidade.associacao ? entidade.associacao.nome : '' }}</p>
            </vs-td>

            <vs-td>
              <div class="text-right">
                <vs-button
                  class="btn-drop editarEntidade"
                  icon="edit"
                  radius
                  size="small"
                  color="#c3c3c3"
                  type="border"
                  id="editarEntidade"
                  dusk="editarEntidade"
                  :to="{name: 'gerenciar-entidade', params: { id: entidade.id }}"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <paginacao :meta="meta" :handler="handlePaginaSelecionada" />
  </div>
</template>

<script>
export default {
  name: "entidades-paginacao",
  created() {
    this.$store.dispatch("RESET_ENTIDADES");
    this.buscarEntidades(1);
  },
  watch: {
    $route(to) {
      this.buscarEntidades(to.query.page);
    },
    loading(loading) {
      if (loading) {
        this.$vs.loading({
          container: "#data-list-list-view",
          scale: 0.6
        });
      } else {
        this.$vs.loading.close("#data-list-list-view > .con-vs-loading");
      }
    }
  },
  computed: {
    loading() {
      return this.$store.getters.isEntidadesLoading();
    },
    entidades() {
      return this.$store.getters.getEntidades();
    },
    meta() {
      return this.$store.getters.getEntidadesMeta();
    }
  },
  methods: {
    buscarEntidades(page) {
      this.$store.dispatch("FETCH_ENTIDADES", {
        page: page,
        ...this.$route.query
      });
    },
    handlePaginaSelecionada(query) {
      this.$router.push({
        name: "entidades",
        query
      });
    },
    handleOrdenacao(key, active) {
      this.$router.push({
        name: "entidades",
        query: {
          ...this.$route.query,
          sortedBy: active ? "asc" : "desc",
          orderBy: key,
          page: 1
        }
      });
    }
  }
};
</script>
